import {all, call, put, select, takeLatest} from 'redux-saga/effects';
import request from 'utils/request';
import {makeSelectUserToken} from 'reducers/selectors/userSelectors';

import {getQueryString} from 'utils/queryString';

import {
  COPY_FOLDER,
  copyFolderFailed,
  copyFolderSuccess,
  CREATE_FOLDER,
  createFolderFailed,
  createFolderSuccess,
  DELETE_FOLDER,
  deleteFolderFailed,
  deleteFolderSuccess,
  FETCH_FOLDER,
  FETCH_FOLDERS,
  FETCH_ICONS,
  fetchFolderFailed,
  fetchFoldersFailed,
  fetchFoldersSuccess,
  fetchFolderSuccess,
  fetchIconsFailed,
  fetchIconsSuccess,
  FILES_INFO,
  filesInfoFailed,
  filesInfoSuccess,
  MOVE_FOLDER,
  moveFolderFailed,
  moveFolderSuccess,
  UPDATE_FILE,
  UPDATE_FOLDER,
  updateFileFailed,
  updateFileSuccess,
  updateFolderFailed,
  updateFolderSuccess,
} from 'actions/documentsActions';

const requestUrl = `document`;

function* fetchFolders(action) {
  const authToken = yield select(makeSelectUserToken());
  const params = getQueryString(action.filters);

  const URL = `document/folders?${params}`;

  try {
    const response = yield call(request, URL, authToken, {});
    yield put(fetchFoldersSuccess(response.folders, response.total));
  } catch (err) {
    yield put(fetchFoldersFailed(err));
  }
}

function* createFolder(action) {
  const authToken = yield select(makeSelectUserToken());

  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(action.details),
  };

  const params = getQueryString(action.filters);

  const URL = `${requestUrl}/${action.companyId}/folder?${params}`;

  try {
    const response = yield call(request, URL, authToken, requestOptions);

    yield put(createFolderSuccess(response.folder));
  } catch (err) {
    yield put(createFolderFailed(err));
  }
}

function* updateFolder(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(action.details),
  };

  const url = action.action
    ? `${requestUrl}/${action.folderId}/folder?action=${action.action}`
    : `${requestUrl}/${action.folderId}/folder`;
  try {
    const response = yield call(request, url, authToken, requestOptions);
    yield put(updateFolderSuccess(response.folder));
  } catch (err) {
    yield put(updateFolderFailed(err));
  }
}

function* updateFile(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(
      request,
      `${requestUrl}/${action.fileId}/file`,
      authToken,
      requestOptions
    );
    yield put(updateFileSuccess(response.pageFolder));
  } catch (err) {
    yield put(updateFileFailed(err));
  }
}

function* moveFolder(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestOptions = {
    method: 'PUT',
  };

  const URL = action.moveFolderId
    ? `${requestUrl}/${action.folderId}/move?moveFolderId=${action.moveFolderId}`
    : `${requestUrl}/${action.folderId}/move?categoryType=${action.categoryType}`;

  try {
    const response = yield call(request, URL, authToken, requestOptions);
    yield put(moveFolderSuccess(response.folder));
  } catch (err) {
    yield put(moveFolderFailed(err));
  }
}

function* copyFolder(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestOptions = {
    method: 'PUT',
  };

  const URL = `${requestUrl}/${action.folderId}/copy`;

  try {
    const response = yield call(request, URL, authToken, requestOptions);
    yield put(copyFolderSuccess(response.folder));
  } catch (err) {
    yield put(copyFolderFailed(err));
  }
}

function* deleteFolder(action) {
  const authToken = yield select(makeSelectUserToken());

  const requestOptions = {
    method: 'DELETE',
  };

  const URL = `${requestUrl}/${action.folderId}/folder`;

  try {
    const response = yield call(request, URL, authToken, requestOptions);

    yield put(deleteFolderSuccess(response.folder));
  } catch (err) {
    yield put(deleteFolderFailed(err));
  }
}

function* filesInfo(action) {
  const authToken = yield select(makeSelectUserToken());
  // const params = getQueryString(action.filters);

  const URL = `company/${action.companyId}/information`;

  try {
    const response = yield call(request, URL, authToken, {});
    yield put(filesInfoSuccess(response.info));
  } catch (err) {
    yield put(filesInfoFailed(err));
  }
}

function* fetchFolder(action) {
  const authToken = yield select(makeSelectUserToken());
  const URL = `${requestUrl}/${action.folderId}`;
  try {
    const response = yield call(request, URL, authToken, {});
    yield put(fetchFolderSuccess(response.folder));
  } catch (err) {
    yield put(fetchFolderFailed(err));
  }
}

function* fetchIcons(action) {
  const authToken = yield select(makeSelectUserToken());
  const params = getQueryString(action.filters);
  const URL = `document/icons/list?${params}`;
  try {
    const response = yield call(request, URL, authToken, {});
    yield put(fetchIconsSuccess(response.folders));
  } catch (err) {
    yield put(fetchIconsFailed(err));
  }
}

export default function* documentsSagas() {
  yield all([
    takeLatest(FETCH_FOLDERS, fetchFolders),
    takeLatest(CREATE_FOLDER, createFolder),
    takeLatest(UPDATE_FOLDER, updateFolder),
    takeLatest(UPDATE_FILE, updateFile),
    takeLatest(MOVE_FOLDER, moveFolder),
    takeLatest(DELETE_FOLDER, deleteFolder),
    takeLatest(COPY_FOLDER, copyFolder),
    takeLatest(FILES_INFO, filesInfo),
    takeLatest(FETCH_FOLDER, fetchFolder),
    takeLatest(FETCH_ICONS, fetchIcons),
  ]);
}
